export const state = {
    dialogState: false,
    dialogLoading: false,
}
